<script lang="ts">
    import { _ } from "svelte-i18n"
    import { fade } from "svelte/transition"
    import ChevronLeftIcon from "svelte-material-icons/ChevronLeft.svelte"
    import CartIcon from "svelte-material-icons/Cart.svelte"
    import FormatAlignLeftIcon from "svelte-material-icons/FormatAlignLeft.svelte"
    import FormatVerticalAlignBottomIcon from "svelte-material-icons/FormatVerticalAlignBottom.svelte"
    import FileIcon from "svelte-material-icons/File.svelte"
    import FormInputText from "../widgets/FormInputText.svelte"
    import WebShareButton from "../widgets/WebShareButton.svelte"

    import ProductImage from "../product/ProductImage.svelte"
    import ProductThumbnails from "../product/ProductThumbnails.svelte"

    import { getProduct, getProducts } from "../../api"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import NotFound from "./NotFound.svelte"
    import { cartOverlay, checkoutData, contentOverlay, login, location, addItemToCart } from "../../store"
    import { getProductPrice } from "../../utils"
    import ProductTeaserList from "../product/ProductTeaserList.svelte"
    import { title } from "../../config"
    import ProductOptions from "../product/ProductOptions.svelte"
    import ProductInquiry from "../product/ProductInquiry.svelte"
    import { navigate } from "../../../../vendor/svelte-routing"
    import FormInputCheckbox from "../widgets/FormInputCheckbox.svelte"
    import { formatPriceCurrency, langField } from "../../i18n"
    import ProductAvailabilityStatus from "../widgets/ProductAvailabilityStatus.svelte"
    import Stars from "../product/Stars.svelte"
    import CustomerRatingComment from "../product/CustomerRatingComment.svelte"
    import EngravingPreview from "../widgets/EngravingPreview.svelte"
    import Index from "../SEO/Index.svelte"

    export let code: string
    let loading = true
    let product: Product
    let activeImage: ImageEntry
    let activeColor: RALColor = undefined
    let activeOptions: string[] = []
    let imageColorMismatch = false

    $: if (code) {
        getProduct(code).then((p) => {
            loading = false
            product = p
        })
    } else {
        loading = false
        product = undefined
    }

    let activeTab = "descr"
    let quantity = 1
    let ratingsShown = 4

    $: {
        if (typeof quantity === "string") {
            quantity = parseInt(quantity)
        }
        if (quantity < 1) {
            quantity = 1
        }
    }

    let user_inputs: CartUserInputs = {}

    const hash = $location.hash?.replace(/^#/, "")
    console.log($location)
    if (hash) {
        console.log(hash)
        try {
            const hObj = JSON.parse(atob(hash))
            console.log(hObj)
            if (hObj) {
                activeColor = hObj.activeColor
                activeOptions = hObj.activeOptions
            }
        } catch (e) {
            console.log(e)
        }
    }

    function navigationToHash(hash: string) {
        navigate($location.path + "#" + hash, { replace: true })
    }
    $: {
        let hash = ""
        if (typeof btoa !== "undefined") {
            hash = btoa(
                JSON.stringify({
                    activeColor,
                    activeOptions,
                })
            )
        }
        navigationToHash(hash)
    }

    let randomKeyNumber = false

    $: if (randomKeyNumber) {
        user_inputs.key_number = -1
    } else {
        user_inputs.key_number = null
    }

    let inputValid = false
    $: {
        let invalid = false

        if (product) {
            if (
                (product.user_inputs?.engraving_line_length_1 ||
                    product.user_inputs?.engraving_line_length_2 ||
                    product.user_inputs?.engraving_line_length_3) &&
                !user_inputs?.engraving_line_1 &&
                !user_inputs?.engraving_line_2 &&
                !user_inputs?.engraving_line_3
            ) {
                invalid = true
            }

            if (
                product.user_inputs?.key_number_range_from &&
                product.user_inputs?.key_number_range_to &&
                user_inputs?.key_number !== -1 &&
                (!user_inputs?.key_number ||
                    user_inputs?.key_number < product.user_inputs?.key_number_range_from ||
                    user_inputs?.key_number > product.user_inputs?.key_number_range_to)
            ) {
                invalid = true
            }
        }

        inputValid = !invalid
    }

    // reset on product change
    $: if (!product?.user_inputs?.engraving_line_length_1) delete user_inputs.engraving_line_1
    $: if (!product?.user_inputs?.engraving_line_length_2) delete user_inputs.engraving_line_2
    $: if (!product?.user_inputs?.engraving_line_length_3) delete user_inputs.engraving_line_3
    $: if (!product?.user_inputs?.key_number_range_from || !product?.user_inputs?.key_number_range_from)
        delete user_inputs.key_number

    $: {
        if (product) {
            let rating = typeof window !== "undefined" ? JSON.parse(window.localStorage.getItem(product.id)) : null
            if (rating) {
                let included = false
                if (!product.ratings) product.ratings = []
                for (let i = 0; i < product.ratings.length; i++) {
                    if (product.ratings[i].orderId === rating.orderId) {
                        included = true
                        product.ratings[i] = rating
                    }
                }
                if (!included) {
                    product.ratings.push(rating)

                    if (isNaN(product.amountOfRatings)) {
                        product.amountOfRatings = 1
                        product.averageRating = rating.rating
                    } else {
                        product.amountOfRatings++
                        product.averageRating =
                            (product.averageRating * (product.amountOfRatings - 1) + rating.rating) /
                            product.amountOfRatings
                    }
                } else {
                    product.averageRating =
                        product.ratings.reduce((acc, cur) => acc + cur.rating, 0) / product.ratings.length
                    product.amountOfRatings = product.ratings.length
                }
            }
        }
    }
    function generateProductMetaKeywords(product: TProduct): string {
        const categories = product.categories
        const title = langField(product.name)
        const description = product.description
        const salePrice = `${product.price_net_end_customer} EUR`
        const keywords = [...categories, title, description, salePrice]
        const uniqueKeywords = Array.from(new Set(keywords)) // Remove duplicates
        const metaKeywordsString = uniqueKeywords.join(", ")
        return metaKeywordsString
    }

    function returnMetaDescription(product: TProduct): string {
        const metaDescription = `Entdecken Sie den ${langField(product.name)} von Renz - Hochwertige Lösungen für Briefkästen, Paketboxen und mehr. Perfekte Kombination aus Design, Sicherheit und Funktionalität.`
        return metaDescription
    }
</script>

{#if loading}
    <MiniLoader />
{/if}

{#if product}
    <Index
        createdAt="{new Date(product.updateTime)}"
        updatedAt="{new Date(product.updateTime)}"
        metaDescription="{returnMetaDescription(product)}"
        title="{langField(product.name)}"
        {product}
        keywords="{generateProductMetaKeywords(product)}"
    />
    <section class="section-type-1 section_padding">
        <div class="container">
            <div class="product_details">
                <div class="section1">
                    <div class="images">
                        <ProductThumbnails {product} bind:activeImage bind:activeColor />
                        <ProductImage
                            {product}
                            {activeImage}
                            alt="{langField(product.name, '')}"
                            {activeColor}
                            {activeOptions}
                            bind:imageColorMismatch
                        />
                    </div>
                    <div class="text">
                        <div class="link-row">
                            <a
                                href="/"
                                class="backbutton"
                                on:click="{(e) => {
                                    e.preventDefault()
                                    history.back()
                                }}"
                            >
                                <ChevronLeftIcon size="24px" />
                                {$_("product.back-to-overview")}
                            </a>
                            <WebShareButton
                                title="{langField(product.name, '')}"
                                text="{langField(product.description, '')}"
                                url="{'https://shop.renzgroup.de' + $location.path}"
                            />
                        </div>

                        <h1>{langField(product.name, "")}</h1>
                        <div class="description"></div>
                        <div class="artnr">
                            {$_("product.item-number-short")}
                            {product.code}
                            {#if product.gtin}
                                &nbsp; | &nbsp;
                                {$_("product.gtin")}
                                {product.gtin}
                            {/if}
                        </div>
                        {#if product.amountOfRatings > 0}
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div
                                class="ratings-row"
                                on:click="{() => {
                                    let rating = document.getElementById(`${product.id}-rating`)
                                    if (rating) {
                                        activeTab = 'rating'
                                        rating.scrollIntoView({ behavior: 'smooth' })
                                    }
                                }}"
                            >
                                <Stars stars="{product.averageRating}" identifier="{product.id}" />
                                <div class="ratings">
                                    {product.amountOfRatings}
                                    {product.amountOfRatings == 1
                                        ? $_("ratings.customer-review")
                                        : $_("ratings.customer-reviews")}
                                </div>
                            </div>
                        {/if}
                        {#if product.variant_codes?.length}
                            {#await getProducts({ code: { $in: product.variant_codes } }, null, null, null, "variant")}
                                <MiniLoader />
                            {:then { data: variants }}
                                {#if variants?.length}
                                    <br />
                                    <label for="variant-select" style="font-size: 0.7em; font-weight: bold;">
                                        {$_("product.variant")}
                                    </label>
                                    <select
                                        id="variant-select"
                                        on:change="{(e) => {
                                            // we have to read selected value from option (svelte internals), because value is string "[Object object]"
                                            /** @type {Product} */ // @ts-ignore
                                            const v = e.target.querySelector('option:checked')?.__value

                                            const detailsHref =
                                                ($location.path && $location.path != '/' ? $location.path + '/' : '') +
                                                '../' +
                                                v.code +
                                                '_' +
                                                langField(v.slug, '')
                                            navigate(detailsHref, { replace: true })
                                        }}"
                                    >
                                        {#each variants.sort((a, b) => {
                                            // order by product.variant_codes array order
                                            return product.variant_codes.indexOf(a.code) - product.variant_codes.indexOf(b.code)
                                        }) as variant}
                                            <option value="{variant}" selected="{product.code == variant.code}">
                                                {langField(variant?.variant_name, $_("product.1-piece"))}</option
                                            >
                                        {/each}
                                    </select>
                                {/if}
                            {/await}
                        {/if}

                        <ProductAvailabilityStatus {product} />

                        <div class="product-seal">
                            <a
                                href="https://www.n-tv.de/ratgeber/Life-Living-Award-2024-Das-sind-Deutschlands-beliebteste-Marken-article24796258.html"
                                target="_blank"
                                rel="nofollow"
                                ><img src="media/beliebter-anbieter.svg" alt="Beliebter Anbieter 2024" /></a
                            >
                            <img src="media/made-in-eu.svg" alt="Made in EU" />
                        </div>

                        <div class="price">
                            {$formatPriceCurrency(
                                getProductPrice(product, activeColor, activeOptions, !!$login),
                                $login ? 0 : $checkoutData.vat
                            )}
                        </div>
                        <div class="mwst">
                            {#if product.inquiry}{$_("product.retail-price")}{/if}
                            {#if $login}
                                {$_("product.excl-vat")}
                            {:else}
                                {$_("product.incl-vat")}
                            {/if}
                            {#if !product.inquiry}
                                ,
                                {#if $login}
                                    <a
                                        href="/service/versandkosten-haendler"
                                        on:click|preventDefault="{() => {
                                            $contentOverlay = '/service/versandkosten-haendler'
                                        }}">{$_("product.plus-shipping")}</a
                                    >
                                {:else}
                                    <a
                                        href="/service/versandkosten"
                                        on:click|preventDefault="{() => {
                                            $contentOverlay = '/service/versandkosten'
                                        }}">{$_("product.plus-shipping")}</a
                                    >
                                {/if}
                            {/if}
                        </div>
                        {#if $login}
                            <div class="dealerInfo">
                                {product.price_net_dealer_is_fixed
                                    ? $_("product.dealer-fixed-price-info")
                                    : $_("product.dealer-conditions-info")}
                            </div>
                        {/if}

                        <ProductOptions {product} bind:activeColor bind:activeOptions {imageColorMismatch} />

                        {#if product.user_inputs && Object.keys(product.user_inputs).length}
                            <form class="gravur_fields">
                                <div class="row">
                                    {#if product.user_inputs?.key_number_range_from && product.user_inputs.key_number_range_to}
                                        {#if product.user_inputs?.key_number_random_ok}
                                            <div class="col-md-12">
                                                <FormInputCheckbox
                                                    bind:checked="{randomKeyNumber}"
                                                    label="{$_('product.any-key-number')}"
                                                />
                                            </div>
                                        {/if}
                                        {#if !randomKeyNumber}
                                            <div class="col-md-12">
                                                <FormInputText
                                                    name="schluesselnummer"
                                                    placeholder="{$_('product.key-number')}"
                                                    bind:value="{user_inputs.key_number}"
                                                    type="number"
                                                    min="{product.user_inputs?.key_number_range_from}"
                                                    max="{product.user_inputs?.key_number_range_to}"
                                                    step="{1}"
                                                    decimals="{0}"
                                                />
                                                <div class="infotext">
                                                    {$_("product.key-number-in-range-from")}
                                                    <span class="num">{product.user_inputs?.key_number_range_from}</span
                                                    >
                                                    {$_("product.key-number-in-range-to")}
                                                    <span class="num">{product.user_inputs?.key_number_range_to}</span>
                                                </div>
                                            </div>
                                        {/if}
                                    {/if}
                                    {#if product.user_inputs?.engraving_line_length_1}
                                        {#if product.lasersheet_configurator}
                                            <!-- TODO evaluate flag for preview -->
                                            <div class="col-md-12" style="padding-bottom: 0px;">
                                                <EngravingPreview
                                                    line1="{user_inputs.engraving_line_1}"
                                                    line2="{user_inputs.engraving_line_2}"
                                                    line3="{user_inputs.engraving_line_3}"
                                                />
                                            </div>
                                        {/if}
                                        <div class="col-md-6">
                                            <FormInputText
                                                name="gravur_zeile1"
                                                placeholder="{$_('product.engraving-line-1')}"
                                                bind:value="{user_inputs.engraving_line_1}"
                                                maxlength="{product.user_inputs?.engraving_line_length_1}"
                                            />
                                            <div class="infotext">
                                                {@html $_("product.count-characters-left-html", {
                                                    values: {
                                                        count:
                                                            product.user_inputs?.engraving_line_length_1 -
                                                            (user_inputs.engraving_line_1?.length || 0),
                                                    },
                                                })}
                                            </div>
                                        </div>
                                    {/if}
                                    {#if product.user_inputs?.engraving_line_length_2}
                                        <div class="col-md-6">
                                            <FormInputText
                                                name="gravur_zeile2"
                                                placeholder="{$_('product.engraving-line-2')}"
                                                bind:value="{user_inputs.engraving_line_2}"
                                                maxlength="{product.user_inputs?.engraving_line_length_2}"
                                            />
                                            <div class="infotext">
                                                {@html $_("product.count-characters-left-html", {
                                                    values: {
                                                        count:
                                                            product.user_inputs?.engraving_line_length_2 -
                                                            (user_inputs.engraving_line_2?.length || 0),
                                                    },
                                                })}
                                            </div>
                                        </div>
                                    {/if}
                                    {#if product.user_inputs?.engraving_line_length_3}
                                        <div class="col-md-6">
                                            <FormInputText
                                                name="gravur_zeile3"
                                                placeholder="{$_('product.engraving-line-3')}"
                                                bind:value="{user_inputs.engraving_line_3}"
                                                maxlength="{product.user_inputs?.engraving_line_length_3}"
                                            />
                                            <div class="infotext">
                                                {@html $_("product.count-characters-left-html", {
                                                    values: {
                                                        count:
                                                            product.user_inputs?.engraving_line_length_3 -
                                                            (user_inputs.engraving_line_3?.length || 0),
                                                    },
                                                })}
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </form>
                        {/if}
                        <div class="buttons emphazised-bg">
                            {#if product.inquiry}
                                <button
                                    on:click="{() => {
                                        $contentOverlay = {
                                            component: ProductInquiry,
                                            props: {
                                                product,
                                                activeColor,
                                                activeOptions,
                                            },
                                        }
                                    }}"
                                    class="btn btn-secondary"
                                >
                                    {$_("product.make-inquiry")}
                                </button>
                            {:else}
                                <div class="counter">
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <button
                                        class="btn btn-transparent"
                                        on:click="{() => {
                                            quantity--
                                        }}">-</button
                                    >
                                    <span class="nr">
                                        <span>Anzahl</span>
                                        <FormInputText
                                            name="quantity"
                                            placeholder="{$_('product.quantity')}"
                                            bind:value="{quantity}"
                                            type="number"
                                        />
                                    </span>
                                    <button
                                        class="btn btn-transparent"
                                        on:click="{() => {
                                            quantity++
                                        }}">+</button
                                    >
                                </div>
                                <button
                                    class="btn btn-secondary cart-btn"
                                    disabled="{!inputValid}"
                                    on:click="{() => {
                                        // @ts-ignore
                                        $cartOverlay = true
                                        addItemToCart({
                                            quantity,
                                            product,
                                            user_inputs: JSON.parse(JSON.stringify(user_inputs)),
                                            price: {
                                                base: $login
                                                    ? product.price_net_dealer
                                                    : product.price_net_end_customer,
                                                unit: getProductPrice(product, null, null, !!$login),
                                            },
                                        }) // deep clone, sonst ist Eingabe an Warenkorb gekoppelt
                                    }}"
                                    >{$_("product.add-to-cart")} &nbsp;
                                    <CartIcon size="24px" /></button
                                >
                            {/if}
                            <!--
                                <a href="/" class="btn">Vergleichen
                                    &nbsp;
                                    <ViewColumnIcon size="24px" /></a>
                                -->
                        </div>
                    </div>
                </div>
                <div class="section2">
                    <div class="tabs">
                        <ul class="tabmenu">
                            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                            <li
                                class:active="{activeTab == 'descr'}"
                                on:click="{() => {
                                    activeTab = 'descr'
                                }}"
                                on:keydown
                            >
                                <FormatAlignLeftIcon />
                                {$_("product.description")}
                            </li>
                            {#if langField(product.downloads, []).length}
                                <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                                <li
                                    class:active="{activeTab == 'download'}"
                                    on:click="{() => {
                                        activeTab = 'download'
                                    }}"
                                    on:keydown
                                >
                                    <FormatVerticalAlignBottomIcon />
                                    {$_("product.downloads")}
                                </li>
                            {/if}

                            {#if product.ratings?.filter((rating) => rating.comment).length > 0}
                                <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                                <li
                                    id="{product.id}-rating"
                                    class:active="{activeTab == 'rating'}"
                                    on:click="{() => {
                                        activeTab = 'rating'
                                    }}"
                                    on:keydown
                                >
                                    <svg
                                        class="star"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18.75 8.125h-6.719L10 1.875l-2.031 6.25H1.25l5.469 3.75-2.11 6.25L10 14.219l5.39 3.906-2.109-6.25 5.469-3.75z"
                                            stroke-linejoin="round"
                                        ></path>
                                    </svg>
                                    {$_("ratings.customer-reviews")}
                                </li>
                            {/if}
                        </ul>
                        {#if activeTab == "download" && langField(product.downloads, []).length}
                            <div class="tabcontent" in:fade="{{}}">
                                <ul class="downloadlist">
                                    {#each langField(product.downloads) as d}
                                        <li>
                                            <a href="{d.file.src}" target="_black">
                                                <span class="icon">
                                                    <FileIcon />
                                                </span>
                                                {d.label || d.file.path}
                                            </a>
                                        </li>
                                    {/each}
                                </ul>
                            </div>
                        {:else if activeTab == "rating"}
                            <div class="tabcontent ratings-container" in:fade="{{}}">
                                {#each product.ratings as rating, i}
                                    <CustomerRatingComment {rating} nr="{i}" {ratingsShown} />
                                {/each}
                                <button
                                    class="show-more"
                                    on:click="{() => (ratingsShown += 4)}"
                                    class:hidden="{product.ratings.length <= ratingsShown}"
                                >
                                    <p>{$_("ratings.show-more")}</p>
                                    <img src="/media/arrow-down-circle.svg" alt="arrow-down" />
                                </button>
                            </div>
                        {:else}
                            <div class="tabcontent prewrap" in:fade="{{}}">
                                {langField(product.description, "")}
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Related Products -->
    {#if product.related_codes?.length}
        <section class="section-type-1 section_padding" id="products_start">
            <div class="container">
                <ProductTeaserList
                    title2="Passende Produkte"
                    filter="{{
                        $or: [{ code: { $in: product.related_codes } }, { base_code: { $in: product.related_codes } }],
                    }}"
                    limit="{99999}"
                />
            </div>
        </section>
    {/if}
{:else if !loading}
    <NotFound />
{/if}

<style lang="less">
    @import "../../css/variables.less";
    .product-seal {
        display: inline-flex;
        flex-flow: wrap;
        gap: 20px;
        justify-content: flex-end;
        margin-top: -48px;
        margin-bottom: 0;
        @media (max-width: 1024px) {
            margin-top: 0;
            justify-content: flex-start;
        }
        @media (max-width: 550px) {
            justify-content: flex-end;
            margin-top: -48px;
        }
        @media (max-width: 400px) {
            margin-top: 0;
            justify-content: flex-start;
        }
        a {
            display: flex;
            align-items: center;
        }
        img {
            max-width: 80px;
            max-height: 50px;
            width: 100px;
        }
    }

    button:disabled {
        opacity: 0.1;
    }
    .hidden {
        display: none !important;
    }

    .tabmenu {
        li {
            display: flex;
            align-items: center;
            :global(svg) {
                margin-right: 10px;
            }

            .star {
                height: 36px;
                background-color: transparent;
                & path {
                    stroke: var(--on-surface);
                }
                padding: 0px;
            }
        }
    }

    :global {
        .product_details {
            :global {
                .inputholder input[type="checkbox"]:checked ~ label:before {
                    background: var(--primary) !important;
                }
                .inputholder label:before {
                    border-color: var(--primary) !important;
                }
            }

            .section1 {
                .flex();
                flex-wrap: wrap;
                margin-bottom: 50px;
                @media (max-width: 550px) {
                    flex-direction: column;
                }
            }
            .images {
                .flex();
                width: 55%;
                min-height: 480px;

                @media (max-width: 1200px) {
                    width: 50%;
                    flex-direction: column-reverse;
                    min-height: 400px;
                }
                @media (max-width: 768px) {
                    height: auto;
                }
                @media (max-width: 550px) {
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;
                }
                :global {
                    > .image {
                        margin-right: 20px;
                    }
                }
            }
            .text {
                width: 45%;
                padding-left: 20px;
                .flex();
                flex-direction: column;
                color: var(--comp--section-type-1--color);

                @media (max-width: 1200px) {
                    width: 50%;
                }
                @media (max-width: 550px) {
                    width: 100%;
                    height: auto;
                    padding-left: 0px;
                }

                .ratings-row {
                    display: flex;
                    align-items: center;
                    margin: 20px 0px;
                    cursor: pointer;
                    gap: 10px;
                    .ratings {
                        font-size: 0.7rem;
                        padding: 0px;
                        margin: 0px;
                    }
                }
                h1 {
                    font-size: 1.5rem;
                    margin-bottom: 0px;
                    @media (max-width: 1200px) {
                        font-size: 1.8rem;
                    }
                    @media (max-width: 1000px) {
                        font-size: 1.3rem;
                    }
                }
                .artnr {
                    font-size: 0.7rem;
                }
                /*
            .ratings {
                margin: 10px 0px;
            }
            */
                .availability {
                    margin: 20px 0px;
                    .flex();
                    align-items: center;
                    .status {
                        width: 15px;
                        height: 15px;
                        .border-radius(100%);
                        margin-right: 7px;
                        background: var(--surface-3);
                    }
                    .description {
                        font-size: 0.7rem;
                        line-height: 1;
                    }
                    &.status1 {
                        .status {
                            background: var(--comp--product--availability--color--status-1);
                        }
                    }
                    &.status2 {
                        .status {
                            background: var(--comp--product--availability--color--status-2);
                        }
                    }
                    &.status3 {
                        .status {
                            background: var(--comp--product--availability--color--status-3);
                        }
                    }
                    &.status4 {
                        .status {
                            background: var(--comp--product--availability--color--status-4);
                        }
                    }
                    &.status5 {
                        .status {
                            background: var(--comp--product--availability--color--status-5);
                        }
                    }
                }
                .link-row {
                    border-bottom: 1px solid var(--border-color-default);
                    color: var(--comp--section-type-1--color);
                    display: flex;
                    display: -webkit-flex;
                    justify-content: flex-end;
                    align-items: center;
                    text-align: right;
                    padding-bottom: 5px;
                    margin-bottom: 15px;
                    gap: 15px;
                    a {
                        font-size: 0.8rem;
                        display: flex;
                        align-items: center;
                        &:hover {
                            color: var(--primary);
                        }
                    }
                    button {
                        display: none;
                        @media (pointer: coarse) {
                            color: var(--on-background);
                            font-size: 0.8rem;
                            border: 0;
                            background: transparent;
                            display: flex;
                            align-items: stretch;
                            cursor: pointer;
                            transition: all 0.3s;
                            &:before {
                                content: "";
                                display: block;
                                border-left: 1px solid var(--border-color-default);
                                padding-left: 15px;
                            }
                            &:hover {
                                color: var(--primary);
                            }
                        }
                    }
                }
                .price {
                    background-color: var(--comp--product--price--background);
                    color: var(--comp--product--price--color);
                    border-radius: var(--comp--product--price--border-radius);
                    padding: var(--comp--product--price--padding);
                    margin: var(--comp--product--price--margin);
                    font-size: 1.6rem;
                    align-self: flex-start;
                    line-height: 1.2;
                }
                .mwst {
                    font-size: 0.7rem;
                    margin-top: -7px;
                    margin-bottom: 15px;
                }
            }

            .downloadlist {
                list-style-type: none;
                margin: 0;
                padding: 0;
                li {
                    margin: 0;
                    padding: 0;
                }
                li a {
                    .flex();
                    margin-bottom: 10px;
                    align-items: center;
                    .icon {
                        margin-right: 10px;
                        .flex();
                        align-items: center;
                    }
                }
            }
            .gravur_fields {
                input {
                    margin-bottom: 0px !important;
                    border-radius: var(--mainborder-radius) var(--mainborder-radius) 0px 0px;
                }
                .infotext {
                    border: 0;
                    margin-top: 0px;
                    padding: 0px;
                    font-size: 14px;
                    background-color: var(--surface-4);
                    padding: 6px 20px;
                    border: 1px solid var(--secondary);
                    border-top: 0px;
                    border-radius: 0px 0px var(--mainborder-radius) var(--mainborder-radius);
                    :global .num {
                        color: var(--status-green);
                    }
                }
            }
            .buttons {
                margin-top: 20px;
                .flex();
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .btn {
                    margin-right: 10px;
                    &:nth-child(2) {
                        @media (max-width: 1100px) {
                            margin-right: 0;
                        }
                    }
                    &:last-child {
                        margin-right: 0;
                        @media (max-width: 1100px) {
                            width: 100%;
                            text-align: center;
                            margin-top: 10px;
                        }
                        @media (max-width: 550px) {
                            width: auto;
                            margin-top: 0px;
                        }
                        @media (max-width: 420px) {
                            width: 100%;
                            margin-top: 10px;
                        }
                    }
                }
            }
            .ratings-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                width: 100%;
                .show-more {
                    display: flex;
                    background-color: transparent;
                    border: 0px solid black;
                    flex-direction: column;
                    align-items: center;
                    font-size: 1.6rem;
                    color: #9a9a9a;
                    p {
                        margin-bottom: 10px;
                    }
                    img {
                        width: 48px;
                        height: 48px;
                    }
                }
            }
            .buttons {
                &.emphazised-bg {
                    background: linear-gradient(to bottom, #ffffff00, #ffffff);
                    padding: 12px 24px;
                    border: 1px solid var(--secondary);
                    border-radius: 6px;
                }
                align-items: flex-end;
                .cart-btn {
                    margin-bottom: 5px;
                }
                .counter {
                    display: flex;
                    align-items: center;

                    button {
                        border: none;
                        background: none;
                        font-size: 24px;
                        width: 60px;
                        padding: 0px;
                        margin: 0px !important;
                        margin-top: 20px !important;
                        display: flex;
                        align-items: center;
                        flex: 1;
                        cursor: pointer;
                        align-self: stretch;
                        font-weight: 700;
                    }
                    .nr {
                        font-weight: 700;
                        width: 60px;

                        text-align: center;
                        font-size: 1rem;
                        span {
                            font-size: 0.7rem;
                            font-weight: 300;
                        }
                        :global {
                            input::-webkit-outer-spin-button,
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none;
                                margin: 0;
                            }

                            /* Firefox */
                            input[type="number"] {
                                -moz-appearance: textfield;
                                appearance: textfield;
                                // border: none;
                                height: 40px;
                                width: 60px;
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
